// extracted by mini-css-extract-plugin
module.exports = {"title":"VideoGrid_title__2pYes","videoGrid":"VideoGrid_videoGrid__3C9GX","videoGridItem":"VideoGrid_videoGridItem__1-_ro"};